import CookieNotification from './components/cookieNotification';
import axios from 'axios';
import Menu from './components/megamenu';
import Tabs from './components/tabs';
import Recaptcha from './components/recaptcha';
import Checkbox from './components/checkbox';
import VideoPlayer from './components/videoplayer';

var myTimeout;

var backupUrl = '';

/* Animation between pages in progress ...  */


// Note, we are purposely binding our listener on the document object
// so that we can intercept any anchors added in future.

window.addEventListener('onhashchange', e => {

})

window.addEventListener('popstate', function (e) {
  // e.state is equal to the data-attribute of the last image we clicked
  changePage();
});

document.addEventListener('click', function (e) {

  var el = e.target;

  // Go up in the nodelist until we find a node with .href (HTMLAnchorElement)
  while (el && !el.href) {
    el = el.parentNode;
  }

  //! Commenting out this code because it was causing errors for the banner
  // if (el && el.classList.contains('megamenu__link')) {
  //   console.log(el)
  //   var megamenu = document.querySelector('.megamenu');
  //   if (megamenu.classList.contains('megamenu--active')) {
  //     e.preventDefault();
  //     changePage(el.href);
  //   }
  // }

});

function loadPage(url) {
  return axios.get(url)
    .then(function (response) {
      return response.data;
    });
};

var head = document.querySelector('head');

const mainWrapper = document.querySelector('.wrapper');
var main = document.querySelector('main');
var mainheader = document.querySelector('.header');
var header = document.querySelector('.header__actions');

function changePage(url) {
  
  // Note, the URL has already been changed
  var promise = Promise.race([loadPage(url), new Promise(function (resolve, reject) {
    myTimeout = setTimeout(() => {
      document.querySelector('.js-hamburger').classList.add('hamburger--loading');
    }, 400);
  })])
  .then(function (responseText) {
    history.pushState(null, null, url);
    clearTimeout(myTimeout);
    window.scrollTo(0, 0);
      document.querySelector('.js-hamburger').classList.remove('hamburger-is-closing');
      document.querySelector('.js-hamburger').classList.remove('hamburger--loading');
      
      var wrapper = document.createElement('div');

      wrapper.innerHTML = responseText;
      var oldContent = document.querySelector('.page');
      var newContent = wrapper.querySelector('.page');
      
      if (window.location.pathname === "/greida") {
        document.body.removeChild(document.querySelector('main'));
        document.body.removeChild(document.querySelector('.banner'));
        document.body.removeChild(document.querySelector('.header__actions'));
        document.body.removeChild(document.querySelector('header'));
        document.body.removeChild(document.querySelector('footer'));
        document.body.removeChild(document.querySelector('.cartpreview'));
        document.body.appendChild(wrapper.querySelector('main'));
      } else {
        var oldHeader = document.querySelector('.header');
        var newHeader = wrapper.querySelector('.header');
        document.querySelector('.header__actions').classList.remove('header__menu--active');


        if (oldHeader && newHeader) {
          mainWrapper.removeChild(oldHeader);
          mainWrapper.appendChild(newHeader);
        }

        var oldTitle = document.querySelector('title');
        var newTitle = wrapper.querySelector('title');

        if (newTitle.innerText !== oldTitle.innerText) {
          var title = newTitle.innerText;
          head.querySelector('title').innerText = title;
        };

        var oldBanner = document.querySelector('.banner');
        var newBanner = wrapper.querySelector('.banner');

        if (oldBanner) {
          mainWrapper.removeChild(oldBanner);
        }
        if (newBanner) {
          header.insertAdjacentElement('afterEnd', newBanner);
        }
        if (newContent) {
          main.appendChild(newContent);
        }
        if (oldContent) {
          oldContent.parentNode.removeChild(oldContent);
        }
      };
      animateCloseMenu();
      require('./components/blazy.js').apply();

      Checkbox.init();
      Recaptcha.reInit();
      Tabs.init();
      VideoPlayer.init();
      require('./components/accordion.js').initialize();
      require('./components/courseRegister.js').initialize();
      require('./components/dropdown.js').initialize();
      require('./components/modal.js').initialize();
      require('./components/loginDialog.js').initialize();
      require('./components/monthlySub.js').initialize();
      require('./components/quantity.js').initialize();
      require('./components/button.js').initialize();
      require('./components/standardForm.js').initialize();

      require('./modules/timetable/timetable.js').initialize();
      require('./modules/timetable/classRegister.js').initialize();
      require('./components/filter.js').initialize();

    })
    .catch((err) => {
      window.location = url;
      window.location.reload();
      history.pushState(null, null, url);
    });
}

function animateCloseMenu() {
  const megamenuActive = document.querySelector('.megamenu--active')
  if (megamenuActive) {
    Menu.closeMenu();
  };
};
